var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "noti" },
    [
      _c(
        "div",
        {
          staticClass: "icon item",
          class: {
            active: _vm.showNotifications && _vm.$route.name !== "checkout",
            disabled: _vm.isUserSocialNumberMissing
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleNotifications.apply(null, arguments)
            }
          }
        },
        [
          _c("i", { staticClass: "icons" }, [
            _c("i", { staticClass: "alarm icon" }),
            _vm._v(" "),
            _vm.subscriptions &&
            _vm.subscriptions.length > 0 &&
            _vm.$route.name !== "checkout"
              ? _c("i", { staticClass: "ui blue circular label top right" }, [
                  _vm._v(_vm._s(this.subscriptions.length))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.showBlinker
              ? _c("div", { staticClass: "blinker-container" }, [
                  _c("span", { staticClass: "blinker" })
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadeDown" } }, [
        _vm.showNotifications && _vm.$route.name !== "checkout"
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.closeNotifications,
                    expression: "closeNotifications"
                  }
                ],
                staticClass: "notification-container",
                class: _vm.subscriptions.length > 5 ? "scrollable" : ""
              },
              [
                _c("i", {
                  staticClass: "close icon",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.closeNotifications.apply(null, arguments)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "notification-header" }, [
                  _c(
                    "div",
                    {
                      staticClass: "header",
                      staticStyle: { "word-break": "break-all" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm.$t("components.notificationbell.header")) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.subscriptions && _vm.subscriptions.length > 0
                    ? _c("div", { staticClass: "notices" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.subscriptions.length) +
                            " " +
                            _vm._s(_vm.$t("components.notificationbell.new")) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.subscriptions && _vm.subscriptions.length > 0
                  ? _c(
                      "div",
                      { staticClass: "notifications" },
                      _vm._l(_vm.subscriptions, function(notification) {
                        return _c(
                          "div",
                          {
                            key: notification.id,
                            staticClass: "notification",
                            on: {
                              click: function($event) {
                                return _vm.openServiceModal(notification)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "header",
                                staticStyle: { "word-break": "break-all" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.shortString(
                                      notification.product.name,
                                      36
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "subtitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "components.notificationbell.messages.service_unset"
                                  )
                                )
                              )
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _c("div", { staticClass: "notifications" }, [
                      _c("div", { staticClass: "error-message" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "components.notificationbell.messages.no_new"
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "social_number_modal",
          attrs: {
            active: _vm.showMissingSocialNumberModal,
            title: _vm.$t("modals.social_number.title"),
            icons: "big alarm"
          },
          on: {
            acceptmodal: _vm.redirectToProfilePage,
            denymodal: _vm.closeSocialNumberModal
          }
        },
        [
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t("modals.social_number.header", {
                  username: _vm.$auth.user().full_name
                })
              )
            )
          ]),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.$t("modals.social_number.body")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            active: _vm.showNotice,
            title: _vm.$t("modals.missed_something.title"),
            icons: "big alarm",
            totalnotifications: _vm.totalSubscriptions,
            "accept-button-disabled": !!_vm.isUserSocialNumberMissing
          },
          on: {
            acceptmodal: _vm.openNextSubscription,
            denymodal: _vm.toggleBlinker
          }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("modals.missed_something.header")))]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("modals.missed_something.body", {
                  total: _vm.totalSubscriptions
                })
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            active: _vm.almostFinished,
            title: _vm.$t("modals.keep_going.title"),
            icons: "big alarm",
            totalnotifications: _vm.totalSubscriptions,
            "accept-button-disabled": !!_vm.isUserSocialNumberMissing
          },
          on: { acceptmodal: _vm.openNextSubscription }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("modals.keep_going.header")))]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("modals.keep_going.body", {
                  total: _vm.totalSubscriptions
                })
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "overduemodal",
          attrs: {
            active: _vm.showOverdue,
            title: _vm.$t("modals.overdue.title"),
            icons: "big alarm"
          },
          on: { acceptmodal: _vm.payOverduePayment }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("modals.overdue.header")))]),
          _vm._v(" "),
          _c("span", {
            domProps: { innerHTML: _vm._s(_vm.$t("modals.overdue.body")) }
          }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "box-actions" }, slot: "box-actions" }, [
            _c(
              "div",
              {
                staticClass: "ui red basic circular button",
                on: {
                  click: function($event) {
                    return _vm.$refs.overduemodal.denyModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n           " +
                    _vm._s(_vm.$t("globals.buttons.cancel")) +
                    "\n         "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui yellow circular button",
                on: {
                  click: function($event) {
                    return _vm.updateOverduePaymentCard()
                  }
                }
              },
              [
                _vm._v(
                  "\n           " +
                    _vm._s(_vm.$t("modals.overdue.update_card")) +
                    "\n         "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ui blue circular button",
                class: _vm.isUserSocialNumberMissing ? "disabled" : "",
                on: {
                  click: function($event) {
                    return _vm.$refs.overduemodal.acceptModal()
                  }
                }
              },
              [
                _vm._v(
                  "\n           " +
                    _vm._s(_vm.$t("globals.buttons.pay")) +
                    "\n         "
                )
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7821e285", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7821e285","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/NotificationBell.vue
// module id = T7YA
// module chunks = 1